import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class GeoDropdownService {

  _items = new Subject<any[]>();
  items: Observable<any>  = this._items.asObservable();

  _isOpen = new Subject<boolean>();
  isOpen: Observable<any> = this._isOpen.asObservable();

  update (items) {
    this._items.next(items);
  }

  open () {
    this._isOpen.next(true);
  }

  close () {
    this._isOpen.next(false);
  }
}
